import React, { useEffect, useState } from 'react';

export default function BusinessForm(props) {
    const [identification, setIdentification] = useState('');
    const [estNumber, setEstNumber] = useState('');
    const [social, setSocial] = useState('');
    const [name, setName] = useState('');
    const [comercialName, setComercialName] = useState('');
    const [email, setEmail] = useState('');
    const [direction, setDirection] = useState('');
    const [mision, setMision] = useState('');
    const [vision, setVision] = useState('');
    const [phone, setphone] = useState('');
    const [cellPhone, setCellPhone] = useState('');
    const [obj, setObj] = useState('');

    useEffect(() => {
        if (props.formData.length > 0) {
            const datForm = props.formData[0];
            setName(datForm['name']);
            setIdentification(datForm['identification']);
            setEstNumber(datForm['establishment']);
            setSocial(datForm['comercialName']);
            setComercialName(datForm['comercialName']);
            setEmail(datForm['email']);
            setDirection(datForm['direction']);
            setMision(datForm['mision']);
            setVision(datForm['vision']);
            setObj(datForm['objetive']);
            setphone(datForm['phone']);
            setCellPhone(datForm['cellphone']);
        }
    }, [props]);

    return (
        <form action="/" method="POST" onSubmit={(e) => { props.handledSave(e) }}>
            <div className="row">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-2">
                            <div className="form-group">
                                <label>Ruc:</label>
                                : <input type="text"
                                    id="ruc"
                                    name="ruc"
                                    value={identification} onChange={e => setIdentification(e.target.value)}
                                    className="form-control"
                                    placeholder="Ingresar código"
                                    disabled
                                />

                            </div>
                        </div>
                        <div className="col-sm-1">
                            <div className="form-group">
                                <label>Est</label>
                                <input id="est"
                                    name="est"
                                    type="text"
                                    value={estNumber}
                                    maxLength={3}
                                    onChange={e => setEstNumber(e.target.value.replace(/\D/g, ''))}
                                    className="form-control"
                                    disabled
                                    placeholder="Ingresar descripción" />
                            </div>
                        </div>
                        <div className="col-sm-9">
                            <div className="form-group">
                                <label>Nombre</label>
                                <input id="name"
                                    name="social"
                                    type="text"
                                    maxLength={100}
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                    placeholder="Ingresar válido desde"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Razón Social</label>
                                <input id="social"
                                    name="social"
                                    type="text"
                                    maxLength={100}
                                    value={social}
                                    onChange={e => setSocial(e.target.value)}
                                    placeholder="Ingresar válido desde"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Nombre commercial</label>
                                <input id="comercial"
                                    name="comercial"
                                    type="text"
                                    maxLength={100}
                                    value={comercialName}
                                    onChange={e => setComercialName(e.target.value)}
                                    placeholder="Ingresar válido hasta"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Correo</label>
                                <input id="email"
                                    name="email"
                                    type="text"
                                    maxLength={50}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    placeholder="Ingresar precio"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input id="phone"
                                    name="phone"
                                    type="text"
                                    maxLength={10}
                                    value={phone}
                                    onChange={e => setphone(e.target.value.replace(/\D/g, ''))}
                                    placeholder="Ingresar precio"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Celular</label>
                                <input id="cellPhone"
                                    name="cellPhone"
                                    type="text"
                                    maxLength={10}
                                    value={cellPhone}
                                    onChange={e => setCellPhone(e.target.value.replace(/\D/g, ''))}
                                    placeholder="Ingresar precio"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Dirección</label>
                                <input id="direction"
                                    name="direction"
                                    type="text"
                                    value={direction}
                                    maxLength={500}
                                    placeholder="Ingresar descuento"
                                    onChange={e => setDirection(e.target.value)}
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Misión</label>
                                <textarea id="mision"
                                    name="mision"
                                    type="text"
                                    maxLength={1000}
                                    value={mision}
                                    onChange={e => setMision(e.target.value)}
                                    placeholder="Ingresar cobro inicial"
                                    className="form-control">
                                </textarea>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Vision</label>
                                <textarea id="vision"
                                    name="vision"
                                    type="text"
                                    maxLength={1000}
                                    value={vision}
                                    onChange={e => setVision(e.target.value)}
                                    placeholder="Ingresar cobro inicial"
                                    className="form-control">
                                </textarea>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Objetivo</label>
                                <textarea id="obj"
                                    name="obj"
                                    type="text"
                                    maxLength={1000}
                                    value={obj}
                                    onChange={e => setObj(e.target.value)}
                                    placeholder="Ingresar cobro inicial"
                                    className="form-control">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div >
                <div className="card-footer">
                    <div className="float-right">
                        <button type="submit" className="btn btn-info"><i className="far fa-save"></i> Guardar</button>
                    </div>
                </div>
            </div >
        </form>
    )
}
